import { css } from '@adornis/chemistry/directives/css.js';
import type { ColorType } from '@adornis/chemistry/elements/theming/coloring-system.js';
import { XCheckbox } from '@adornis/forms/x-checkbox.js';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import './tr-icon.js';

@customElement('tr-checkbox')
export class TrCheckbox extends XCheckbox {
  @property({ attribute: true }) enableIcon: string | undefined;
  @property({ attribute: true }) disableIcon: string | undefined;

  @property({ attribute: true }) coloring: ColorType | undefined;

  protected _displayIcon() {
    if (this.value.value) return html` <tr-icon ?small=${!!this.enableIcon}> ${this.enableIcon || 'check'} </tr-icon> `;

    if (!this.booleanOnly && typeof this.value.value !== 'boolean') return html` <tr-icon> question_mark </tr-icon> `;

    if (this.disableIcon)
      return html` <tr-icon small ${css({ color: this.colors.dark, opacity: '.75' })}> ${this.disableIcon} </tr-icon> `;

    return nothing;
  }

  protected override _circle() {
    return html` <tr-flex horizontal center crossaxis-center flex-none id="circle"> ${this._displayIcon()} </tr-flex> `;
  }

  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {
          '#circle': !!this.value.value
            ? {
                background: this.coloring ?? this.colors.accent,
              }
            : {
                ...(!!this.disableIcon || this.disableIcon === ''
                  ? {
                      background: 'TRANSPARENT',
                      border: `1px solid ${this.coloring ?? this.colors.dark}`,
                    }
                  : {}),
              },
        },
      },
    ] as any;
  }
}
